export default __webpack_public_path__ + "static/media/not-available.e19e6b4b.svg";